import Grid from './Grid';

export default Grid;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/FullECGPreview/Grid/index.js